module.exports = __webpack_public_path__ + "static/media/word-play-ilus.8f0d6d60.jpg";